import { Button } from 'antd';
import { CodeOutlined } from '@ant-design/icons';
import { FormattedMessage } from 'react-intl';

export const codeblockCommand = ({ editor, range }) =>
  range
    ? editor.chain().focus().deleteRange(range).toggleCodeBlock().run()
    : editor.chain().focus().toggleCodeBlock().run();

const CodeBlock = ({ editor, showLabel = false, indicateActive = true, isExtension = false }) => {
  return (
    <Button
      className={`editor-toolbar-btn-container ${indicateActive && editor.isActive('codeBlock') ? '!bg-slate-100 text-black' : '!bg-transparent'}`}
      icon={<CodeOutlined className="text-gray-800 text-xs" />}
      onClick={isExtension ? () => {} : () => codeblockCommand({ editor })}
      size="small"
      type="text"
    >
      {showLabel && (
        <div className="editor-toolbar-btn-label">
          <FormattedMessage id="CODE_BLOCK" defaultMessage="Code block" />
        </div>
      )}
    </Button>
  );
};

export default CodeBlock;
